import Link from '@Components/common/Link';
import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const Card = styled(Link)`
  max-width: 769px;
  width: 100%;
  padding: 10px 32px;
  border: 1px solid ${({ theme }) => theme.colors.counter};
  border-radius: 4px;
  margin: 0 auto 16px auto;
  cursor: pointer;
  &:last-of-type {
    margin: 0 auto;
  }
  ${mq(576)} {
    padding: 10px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.counter};
  margin-bottom: 18px;
  ${mq(576)} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ReservationNumber = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  ${mq(576)} {
    margin-bottom: 8px;
  }
`;

export const Status = styled.p`
  padding: 0 14px;
  height: 36px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.counter};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  text-align: center;
  line-height: 36px;
  ${mq(576)} {
    width: auto;
    line-height: 1.3;
    padding: 10px;
  }
`;

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Content = styled(Div)`
  ${mq(576)} {
    /* align-items: flex-start; */
    /* flex-direction: column; */
  }
`;

export const IconWrapper = styled.div`
  max-width: 58px;
  min-width: 58px;
  max-height: 58px;
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.innerProduct.gray};
`;

export const NumberOfProducts = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  margin-bottom: 12px;
`;

export const ProductImageWrapper = styled.div`
  max-width: 24px;
  min-width: 24px;
  max-height: 24px;
  min-height: 24px;
  margin-right: 4px;
  border-radius: 50%;
  border: 1px solid #d5d5d5;
  overflow: hidden;
`;

export const TotalTitle = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.lightenPurple};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  margin-bottom: 10px;
`;

export const Total = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body18};
`;
